import { inject, Injectable, Signal } from '@angular/core';
import { SelectProfileRequestParams } from '@lentau/profile/shared/interfaces/profile-common-info';
import { Observable } from 'rxjs';
import { isLenta } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';
import { B2BOrganizationsStore } from '../store/b2b-organizations.store';
import { ResponseErrorListItemProps } from '@lentau/api/shared/monolith/types';
import { LegalEntityListItem } from 'angular-api-gateway/v1/model/legalEntityListItem';

@Injectable({ providedIn: 'root' })
export class B2bOrganizationsFacade {
  private platformService: PlatformService = inject(PlatformService);
  private store: InstanceType<typeof B2BOrganizationsStore> = inject(B2BOrganizationsStore);

  public selectErrorList: Signal<ResponseErrorListItemProps[]> = this.store.errorList;
  public selectOrganizations: Signal<LegalEntityListItem[]> = this.store.organizations;
  public isOrganizationsInit: Signal<boolean> = this.store.isOrganizationsInit;
  public isLoading: Signal<boolean> = this.store.isLoading;
  public hasError: Signal<boolean> = this.store.hasError;

  public selectProfileForAuthorizedSuccess$: Observable<SelectProfileRequestParams> =
    this.store.selectProfileForAuthorizedSuccess$;

  public selectProfileForAuthorizedFail$: Observable<void> = this.store.selectProfileForAuthorizedFail$;

  public getOrganizationsOnAccount(): void {
    if (isLenta() && this.platformService.isBrowser) {
      this.store.getOrganizationsOnAccount();
    }
  }

  public updateOrganizationsOnAccount(): void {
    if (isLenta() && this.platformService.isBrowser) {
      this.store.updateOrganizationsOnAccount();
    }
  }

  public selectProfileForAuthorized(params: SelectProfileRequestParams): void {
    this.store.selectProfileForAuthorized(params);
  }

  public setOrganizationsInit(): void {
    this.store.setOrganizationsInit();
  }

  public resetAll(): void {
    this.store.resetAll();
  }
}
